import { useIntl } from 'react-intl';

export function useMessages() {
  const intl = useIntl();

  const getChannelRecommendationMessages = () => ({
    header: intl.formatMessage({ defaultMessage: 'Limited traction' }),
    description: intl.formatMessage({
      defaultMessage: `Current campaign performance may fall short of hiring goal. Increase budget of the active campaigns or add new campaigns.`,
    }),
  });

  return { getChannelRecommendationMessages };
}
